const DEFAULT_HTML_FONT_SIZE = 16;

export interface Typography {
    fontFamily: string;
    fontSize: string;
    fontWeightNormal: number;
    fontWeightMedium: number;
    fontWeightBold: number;
    pxToRem: (px: number) => string;
}

export function createTypography(props: Partial<Typography> = {}): Typography {
    const pxToRem = (px: number) => `${px / DEFAULT_HTML_FONT_SIZE}rem`;

    // TODO: add ability to add own font styles?

    return {
        fontFamily: '"Brutal", sans-serif',
        fontSize: '14px',
        // Currently Normal, Regular, and Bold are supported for Brutal
        fontWeightNormal: 400,
        fontWeightMedium: 500,
        fontWeightBold: 700,
        pxToRem,
        ...props
    };
}
